import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
// import TagManager from 'react-gtm-module';
import axios from 'axios';

import AppContainer from 'containers/AppContainer';

// Store.
import configureStore, { history } from "store/configureStore";

// Utils.
import { getCookie, setCookie, getLanguage } from 'utils';

// Config.
import { apiURL } from './config';

// Current browser language.
const language = getLanguage();

axios.defaults.baseURL = apiURL;
axios.defaults.withCredentials = true;

setCookie('lang', language);

const csrftoken = getCookie('csrftoken');
if (csrftoken) {
  axios.defaults.headers.post['X-CSRFToken'] = csrftoken;
  axios.defaults.headers.put['X-CSRFToken'] = csrftoken;
  axios.defaults.headers.patch['X-CSRFToken'] = csrftoken;
  axios.defaults.headers.delete['X-CSRFToken'] = csrftoken;
}
axios.defaults.headers.common['Accept-Language'] = language;

// const tagManagerArgs = {
//   gtmId: 'GTM-WN829F3'
// };

// TagManager.initialize(tagManagerArgs);

const initialState = window.__initialState__ || undefined;

const store = configureStore(initialState);

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppContainer history={history} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
